export default "__VITE_ASSET__BanDeDEB__"